import { useEffect, useState } from "react";
import { Sun, Moon, Monitor } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../components/ui/dropdown-menu";

const KEY = "eps_theme";
const mq = window.matchMedia("(prefers-color-scheme: light)");
const resolve = (p) => (p === "system" ? (mq.matches ? "light" : "dark") : p);

const apply = (pref) => {
  const t = resolve(pref);
  document.documentElement.classList.toggle("light", t === "light");
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", t === "light" ? "#F1F5F9" : "#0B1120");
  return t;
};

export const useTheme = () => {
  const [pref, setPrefState] = useState(() => localStorage.getItem(KEY) || "system");
  const [theme, setTheme] = useState(() => resolve(pref));
  useEffect(() => {
    const sync = () => { const p = localStorage.getItem(KEY) || "system"; setPrefState(p); setTheme(apply(p)); };
    sync();
    mq.addEventListener("change", sync);
    window.addEventListener("eps-theme", sync);
    return () => { mq.removeEventListener("change", sync); window.removeEventListener("eps-theme", sync); };
  }, []);
  const setPref = (p) => { localStorage.setItem(KEY, p); window.dispatchEvent(new Event("eps-theme")); };
  return { pref, theme, setPref };
};

const OPTIONS = [["light", "Light", Sun], ["dark", "Dark", Moon], ["system", "Device setting", Monitor]];

export const ThemeToggle = () => {
  const { pref, theme, setPref } = useTheme();
  const Icon = theme === "light" ? Sun : Moon;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex h-11 w-11 items-center justify-center rounded-md transition-colors hover:bg-slate-800" title="Theme" data-testid="theme-toggle-btn"><Icon className="h-5 w-5" /></button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="border-slate-700 bg-ink-2" data-testid="theme-menu">
        {OPTIONS.map(([v, label, I]) => (
          <DropdownMenuItem key={v} onClick={() => setPref(v)} className={pref === v ? "font-semibold text-rose-400" : ""} data-testid={`theme-option-${v}`}>
            <I className="mr-2 h-4 w-4" />{label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
